'use client';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { SvgIcon } from '@/components/SvgIcon';
import iconCircledCheckSrc from '~/svg/IconCircledCheck.svg';
import iconCloseCircledSrc from '~/svg/IconCloseCircled.svg';

type Props = {
  isVisible: boolean;
  status: 'success' | 'error';
};

export const ResponseStatus = ({ isVisible = false, status }: Props) => {
  const { texts } = useTranslation();
  const iconSrc = status === 'error' ? iconCloseCircledSrc : iconCircledCheckSrc;
  const message =
    status === 'error'
      ? texts.scraper.response_status.error
      : texts.scraper.response_status.success;

  return (
    <div
      className={cn(
        'py-2 bg-gray-dark-950 duration-300',
        isVisible
          ? 'translate-y-0 opacity-100 h-full'
          : 'translate-y-full opacity-0 invisible'
      )}
    >
      <div
        className={cn(
          'bg-gray-dark-900 flex w-full items-center justify-center gap-x-2.5 px-2.5 py-0.5 h-6',
          status === 'error' && 'text-error-500',
          status === 'success' && 'text-success-500'
        )}
      >
        <SvgIcon src={iconSrc} className='size-4' />
        <p className='text-label-text-l'>{message}</p>
      </div>
    </div>
  );
};
